import { icon, IconDefinition } from '@fortawesome/fontawesome-svg-core';

export function toUrl(definition: IconDefinition) {
  return `data:image/svg+xml;utf8,${icon(definition).html[0].replace(/"/g, '\'')}`;
}
